import { Tag } from '@applyboard/crystal-ui'
import { IntakeSearchResource } from '@backend/resources/intake-search/types'

type IntakeStatusProps = Readonly<{
  status: IntakeSearchResource['attributes']['intake']['status']
}>

export function IntakeStatus(props: IntakeStatusProps) {
  switch (props.status) {
    case 'OPEN':
      return (
        <Tag intent="positive" size="md">
          Open
        </Tag>
      )
    case 'CLOSED':
      return (
        <Tag intent="secondary" size="md">
          Closed
        </Tag>
      )
    case 'WILL_OPEN':
      return (
        <Tag intent="magic" size="md">
          Opening Soon
        </Tag>
      )
    default:
      return null
  }
}
